(function() {

  function tryAutoPlay() {
    document.querySelectorAll('deferred-media').forEach(function(el) {
      // If video is already loaded, just ensure it plays and loops
      var videos = el.querySelectorAll('video');
      if (videos.length > 0) {
        videos.forEach(function(v) {
          v.loop = true;
          v.muted = true;
          if (v.paused) v.play().catch(function() {});
        });
        return;
      }
      // Otherwise click the deferred media button to trigger load
      var btn = el.querySelector('[data-deferred-media-button]');
      if (btn) btn.click();
    });
  }

  function init() {
    tryAutoPlay();
    // Retry at staggered delays to catch theme JS initialization
    [100, 300, 600, 1000, 2000].forEach(function(delay) {
      setTimeout(tryAutoPlay, delay);
    });
  }

  // Entry point
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Theme events
  document.addEventListener('theme:media:load', tryAutoPlay);
  document.addEventListener('shopify:section:load', init);

  // Watch for deferred-media elements added dynamically (variant/color switches)
  var observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(m) {
      m.addedNodes.forEach(function(node) {
        if (node.nodeType !== 1) return;
        var tag = node.tagName && node.tagName.toLowerCase();
        if (tag === 'deferred-media' || (node.querySelector && node.querySelector('deferred-media'))) {
          setTimeout(tryAutoPlay, 150);
        }
      });
    });
  });
  observer.observe(document.body, { childList: true, subtree: true });

})();
